export default "__VITE_ASSET__CTef82S3__"